import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		warningIcon: {
			color: theme.palette.custom.tagWarningText,
			flexShrink: 0,
		},
		text: {
			fontSize: 18,
			lineHeight: "32px",
			fontWeight: 400,
			color: theme.palette.custom.textPrimary,
		},
	} satisfies Record<string, CSSObject>);
};
